(function () {
    angular
        .module('smartertoolsApp')
        .controller('stLoginRequiredController', ['$scope', '$location', stLoginRequiredController]);

    function stLoginRequiredController($scope, $location) {
        const vm = this;

        // Functions
        vm.getLoginMessage = getLoginMessage;
        vm.getLoginButtonText = getLoginButtonText;
        vm.showHeader = showHeader;
        vm.getHeroImage = getHeroImage;
        vm.getHeadingText = getHeadingText;

        // -----------------------------------------------

        function getHeroImage() {
            switch ($location.$$path) {
                case '/support':
                    return 'sales-hero.jpg';
                default:
                    return 'landing-hero.jpg';
            }
        }

        function getLoginMessage() {
            let retVal = '<p class="centered lighter">';

            switch ($location.$$path) {
                case '/support':
                    retVal += 'Licenses covered by Maintenance and Support receive unlimited technical support and access to all new features, fixes, and improvements to the software. Product installation assistance, product training, and 24x7x365 emergency support options are also available for purchase.';
                    break;
                default:
                    retVal += 'In order to access your account, you must first login.';
                    break;
            }

            retVal += '</p>';

            return retVal;
        }

        function getLoginButtonText() {
            return 'Login';
        }

        function getHeadingText() {
            switch ($location.$$path) {
                case '/support':
                    return 'Technical Support';
                default:
                    return 'My Account';
            }
        }

        function showHeader() {
            switch ($location.$$path) {
                case '/support':
                    return false;
                default:
                    return true;
            }
        }
    }

})();